import { FC } from 'react';

import View from './view';

const DuoDevicePage: FC = () => {
  return <View />;
};
export default DuoDevicePage;
